/* tslint:disable */
import {
  Sector,
  SectorType
} from '../index';

declare var Object: any;
export interface SectorCategoryInterface {
  "name": string;
  "id"?: number;
  "sector_id"?: number;
  "sector_type_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  sector?: Sector;
  sectorType?: SectorType;
}

export class SectorCategory implements SectorCategoryInterface {
  "name": string;
  "id": number;
  "sector_id": number;
  "sector_type_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  sector: Sector;
  sectorType: SectorType;
  constructor(data?: SectorCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SectorCategory`.
   */
  public static getModelName() {
    return "SectorCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SectorCategory for dynamic purposes.
  **/
  public static factory(data: SectorCategoryInterface): SectorCategory{
    return new SectorCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SectorCategory',
      plural: 'SectorCategories',
      path: 'SectorCategories',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "sector_id": {
          name: 'sector_id',
          type: 'number'
        },
        "sector_type_id": {
          name: 'sector_type_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        sector: {
          name: 'sector',
          type: 'Sector',
          model: 'Sector'
        },
        sectorType: {
          name: 'sectorType',
          type: 'SectorType',
          model: 'SectorType'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/SectorCategory.ts